import axios from 'axios';
import { removeNotAllowedHeader } from 'shared/api/removeNotAllowedHeader';

export const authApiClient = axios.create({
  headers: { 'Content-Type': 'multipart/form-data' },
  withCredentials: false,
  transformRequest: [
    removeNotAllowedHeader('X-CSRFToken'),
    removeNotAllowedHeader('Authorization'),
  ],
});
